import React, { useState, useContext } from "react";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { NavigationContext } from "navigation-react";
import DashboardContenLeftMenus from "./DashboardContenLeftMenus";
import DashboardMainContent from "./DashboardMainContent";
import DashboardContentHeader from "./DashboardContentHeader";
import DashboardContentFooter from "./DashboardContentFooter";
import SecureLS from "secure-ls";

const ls = new SecureLS({ encodingType: "aes" });

const DashboardContent = () => {
  const { stateNavigator } = useContext(NavigationContext);
  const userRoles = ls.get("currentuserrole");
  // eslint-disable-next-line no-unused-vars
  const [userRole, setUserRole] = useState(userRoles);

  const navigationRoleCTScan = () => {
    if (userRole.includes("content_editor")) {
      stateNavigator.navigate("screeningcontentmanager");
    } else if (userRole.includes("client_manager")) {
      stateNavigator.navigate("screeningclientmanager");
    } else {
      stateNavigator.navigate("login");
    }
  };

  return (
    <div className="dashboard-container">
      <DashboardContentHeader />
      <div className="content-wrapper">
        <DashboardContenLeftMenus />
        <DashboardMainContent
          AddTitle="Dashboard Main"
          className="content-box"
          ctscaniconImage={faUserPlus}
          ctscaniconLable="Vouchers"
          ctScanonClick={navigationRoleCTScan}
        />
      </div>
      <DashboardContentFooter />
    </div>
  );
};

export default DashboardContent;
